import { User } from '../components/includes/User'
export default {
    state: {
        user: new User(),
        accessToken: null,
    },
    mutations: {
        auth (state, user) {
            state.user = user
        },
        logout (state) {
            state.user = new User()
            state.accessToken = null
        },
        setToken (state, token) {
            state.accessToken = token
        },
        updateUser (state, user) {
            state.user = user
        }
    },
    getters: {
        isAuthenticated (state) {
            return state.user.id !== 0
        },
        user (state) {
            return state.user
        },
        accessToken (state) {
            return state.accessToken
        },
    }
}
